import classNames from "classnames";
import { useCallback } from "react";
import { TreeNode } from "~/components/build/Show/pages/steps/list/components/TreeNode";
import { STEP_ITEM_HEIGHT } from "~/components/build/Show/pages/steps/list/components/constants";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";
import { CommandStep } from "~/lib/pipeline";
import Icon from "~/components/shared/Icon";

interface CommandStepExpandItemProps {
  hiddenCount: number;
  step: CommandStep;
  depth?: number;
}

export const CommandStepExpandItem = ({
  hiddenCount,
  step,
  depth = 0,
}: CommandStepExpandItemProps) => {
  const showHiddenJobs = useBuildStore((state) => state.showHiddenJobs);

  const onClick = useCallback(() => {
    showHiddenJobs(step.uuid);
  }, [showHiddenJobs, step.uuid]);

  return (
    <button
      onClick={onClick}
      className={classNames(
        "text-charcoal-300 hover:bg-purple-100-50-white flex h-full w-full cursor-pointer items-center rounded-md text-left text-xs/5",
        {
          "pl-[2.125rem]": depth === 1,
          "pl-[3.875rem]": depth === 2,
        },
      )}
    >
      <div className="flex w-full items-center gap-x-1 pl-[34px]">
        <Icon
          icon="custom/outline/16x/chevrons-up-down"
          className="text-charcoal-300 h-3 w-3 shrink-0"
        />
        <span className="text-charcoal-300 text-xs font-normal">
          {hiddenCount} hidden, show more
        </span>
      </div>
    </button>
  );
};

export const createShowHiddenJobsNode = (step: CommandStep, hiddenCount: number): TreeNode => ({
  id: `hidden-jobs-${step.uuid}`,
  height: STEP_ITEM_HEIGHT,
  render: ({ depth }) => (
    <CommandStepExpandItem hiddenCount={hiddenCount} step={step} depth={depth} />
  ),
});
